    <template>
      <barSlider />
      <!-- DESTACADOS (carga inmediata) -->
      <destacados style="margin-top: 3%" />
      <!-- Secciones lazy -->
      <template v-for="component in componentOrder" :key="component">
        <!-- sentinel observado -->
        <div class="observer-sentinel" :data-component="component" style="height: 1px;"></div>

        <!-- skeleton -->
        <div v-if="loading[component]">
          <div class="card class-list-view custom-card border-0 mb-3">
            <div class="card-body">
              <div class="row">

                <div class="col-md-3">
                  <div class="bg-light placeholder" style="height:250px;"></div>
                </div>

                <div class="col-md-4">
                  <span class="placeholder col-10 mb-2"></span>
                  <span class="placeholder col-8 mb-2"></span>
                  <span class="placeholder col-6"></span>
                </div>

                <div class="col-md-5">
                  <span class="placeholder col-12"></span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- componente real -->
        <component :is="component" v-if="loaded[component]" />

      </template>
    </template>
<script>
import barSlider from './Components/itemSlider.vue';
//import destacados from '../components/navegation/ComponentsRecomend/CompoentsHome/SeccionProdsDestacar.vue';
import destacados from './Components/SeccionProdsDestacar.vue';
import boletinprodnuevos from './Components/boletinprodnuevos.vue';
import Categorias from './Components/Categorias.vue';
import ComponentWithTemplate from './Components/promocionesdestacadas.vue';
import SliderPromoActivas from './Components//SliderPromoActivas.vue';
import barItem from './Components/itembar.vue';
import PublicacionesBlog from './Components/publicacioneshome.vue';
import itembestbuyprods from './Components/itemsbestbuyprods.vue';
import marcas from './Components/marcaslineas.vue';
import throttle from 'lodash/throttle'

export default {
  name: "Home",
  components: {
    barSlider,
    destacados,
    Categorias,
    boletinprodnuevos,
    ComponentWithTemplate,
    SliderPromoActivas,
    barItem,
    PublicacionesBlog,
    itembestbuyprods,
    marcas,
  },
  data() {
    return {
      componentOrder: [
        'boletinprodnuevos',
        'Categorias',
        'ComponentWithTemplate',
        'SliderPromoActivas',
        'barItem',
        'PublicacionesBlog',
        'itembestbuyprods',
        'marcas'
      ],
      loaded: {},
      loading: {},
      observer: null
    }
  },

  created() {
    // estados iniciales
    this.componentOrder.forEach(c => {
      this.loaded[c] = false
      this.loading[c] = false
    })
  },

  mounted() {
    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: '250px', // precarga antes de entrar
      threshold: 0
    })

    this.$nextTick(() => {
      document
        .querySelectorAll('.observer-sentinel')
        .forEach(el => this.observer.observe(el))
    })
  },

  beforeUnmount() {
    this.observer.disconnect()
  },

  methods: {
    onIntersect(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return

        const component = entry.target.dataset.component

        if (this.loaded[component]) return

        this.loading[component] = true

        // carga inmediata (defineAsyncComponent maneja el chunk)
        this.loaded[component] = true
        this.loading[component] = false

        this.observer.unobserve(entry.target)
      })
    }
  }
}
</script>
<style scoped>
.component-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.skeleton-line {
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 10px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}
</style>